export default {
  UserName: "",
  Active: true,
  Email: "",
  KeepOldPassword: false,
  Role: null,
  Password: "",
  UserModified: localStorage.getItem("UserName"),
};
